import { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import './forgotPassword.scss';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const ForgotPassword = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [loginPage, setLoginPage] = useState<any>(true);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const email = inputRef?.current?.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailRegex.test(email as string)) {
      axios
        .post('/op/auth/request-reset', {
          email: email,
        })
        .then((res) => {
          setLoginPage(false);
        })
        .catch((err) => {
          // setSuccess(true);
          setError('Please enter valid email address!');
        });
    } else {
      setError('Please enter valid email address!');
    }
  };

  return (
    <div id="Login" className="flex">
      <section className="">
        <img alt="Main Icon" className="main-logo" src="/images/sidebar_login.png" />
      </section>
      <section className="flex flex-col items-center justify-center grow">
        {loginPage ? (
          <div>
            <header className="flex flex-col gap-2 mb-10">
              <span className="text-5xl font-extrabold">Forgot Password</span>
              <span className="" style={{ color: '#A6BCCC' }}>
                Enter your email to reset your password.
              </span>
            </header>
            <form className="fields-panel" onSubmit={handleSubmit}>
              <div className="mb-2">
                <label style={{ color: '#5A7283' }} className="text-sm mb-1">
                  Email
                </label>
                <input className="input-login" ref={inputRef} name="email" placeholder="user@mail.com" type="email" />
              </div>

              {error !== '' && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{error}</div>
                </div>
              )}
              <Button className="main-btn" type="submit">
                <span className="indicator-label text-sm">Submit</span>
              </Button>
            </form>
            <div className="flex gap-1 text-sm mt-3">
              <span>Already registered?</span>
              <span
                tabIndex={0}
                className="cursor-pointer font-medium underline "
                style={{ color: '#35B888', fontFamily: 'Inter' }}
                onClick={() => navigate('/login')}
              >
                Login
              </span>
            </div>
          </div>
        ) : (
          <>
            <header className="flex flex-col gap-2 mb-10">
              <span className="text-5xl font-extrabold">Forgot Password</span>
            </header>
            <form className="flex flex-col gap-5 w-96 pt-6" noValidate>
              <div className="flex flex-col items-start gap-2">
                {/* style={{ marginTop: '124px', marginBottom: '150px' }} */}
                <div className="text-xl text-ubuntu">
                  <span>Your request has been submitted!</span>
                  <br />
                  <span>
                    If your email is present in our system, you will receive an email within 30 minutes with a link that will allow you
                    to reset your password.
                  </span>
                </div>
              </div>

              <Button
                className="login-btn mt-2 rounded-xl"
                style={{ backgroundColor: '#19262F' }}
                type="submit"
                id="login-btn"
                variant="outline"
                onClick={() => navigate('/login')}
              >
                <span className="text-white">Return to Login Page</span>
              </Button>
            </form>
          </>
        )}
      </section>
    </div>
  );
};
